import clsx from 'clsx';
import {AnimatePresence, motion} from 'framer-motion';
import {useEffect} from 'react';
import {useMadeToOrderStore} from '../../../hooks/useMadeToOrderStore';
import {SanitySettings} from '../../../types';
import translate from '../../../utils/getTranslation';
import MadeToOrderForm from './MadeToOrderForm.client';

type Props = {
  settings?: SanitySettings;
};

export default function MadeToOrder({settings}: Props) {
  const {isOpen, handleClose, productTitle} = useMadeToOrderStore();

  useEffect(() => {
    {
      isOpen
        ? document.documentElement.classList.add('overflow-hidden')
        : document.documentElement.classList.remove('overflow-hidden');
    }
  }, [isOpen]);

  const TRANSITIONS = {
    DURATION: 0.4,
    EASE: [0.25, 0.1, 0.25, 1.0],
  };

  const VARIANTS = {
    open: {
      x: 0,
      originY: 0,
      opacity: 1,
      transition: {
        duration: TRANSITIONS.DURATION,
        ease: TRANSITIONS.EASE,
      },
    },
    closed: {
      x: `100%`,
      transition: {
        duration: TRANSITIONS.DURATION,
        ease: TRANSITIONS.EASE,
      },
    },
  };

  const CLOSE = translate('CLOSE');

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.nav className="fixed inset-0 z-[90]">
          <Background />
          <motion.div
            variants={VARIANTS}
            initial="closed"
            animate="open"
            exit="closed"
            className="h-screen-safe fixed right-0 flex w-full flex-col bg-neutral-100 text-neutral-900 md:w-1/2"
          >
            <div className="sticky top-0 z-50 flex w-full justify-between gap-6 bg-neutral-100 py-5 px-4 text-sm md:px-8">
              <p>Made to Order</p>
              <button onClick={handleClose} className="hover:underline">
                {CLOSE}
              </button>
            </div>
            <div className="mt-16 text-center">
              <h1 className="translate-y-[.15em] font-kormelink text-3xl leading-none">
                Made <span className="italic">to</span> Order
              </h1>
              <h1 className="translate-y-[.15em] font-kormelink text-3xl uppercase leading-none">
                {productTitle}
              </h1>
            </div>
            {productTitle.length > 0 ? (
              <MadeToOrderForm
                settings={settings}
                productTitle={productTitle}
              />
            ) : (
              <div className="px-4 text-sm md:px-8">
                <div className="mx-auto mt-16 mb-12 max-w-lg text-center">
                  {settings?.madeToOrderText && (
                    <p>{settings.madeToOrderText}</p>
                  )}
                </div>
              </div>
            )}
          </motion.div>
        </motion.nav>
      )}
    </AnimatePresence>
  );
}

function Background() {
  const {toggleOpen} = useMadeToOrderStore();
  return (
    <motion.div
      onClick={toggleOpen}
      initial={{opacity: 0}}
      animate={{opacity: 0.2}}
      exit={{opacity: 0}}
      className={clsx('fixed inset-0 h-screen w-screen', 'bg-neutral-900')}
    ></motion.div>
  );
}
